import React from 'react'
import { Flex, Span, Grid, Input, Label, SearchSelect, Range, Button } from '@fareye/ui'
import { isEmpty, getValueFromNestedKey, startCase } from '@fareye/utils'
import { displayTime, formatForCSV } from '../../../utility/function'
import { PopOverDownloadCSV } from './PopOverDownloadCSV'
import { historyCSVColumns } from '../../../utility/constants'
import { tripTabsBackground } from '@fareye/configs'
import {
  useTranslation,
  dateFormatter,
  parseTemperature,
  parseDoorData,
  parseVoltage
} from '@fareye/common'
const style: any = {
  tripTabs: {
    boxShadow: '0 4px 14px 0 rgba(0,0,0,0.1)',
    backgroundColor: tripTabsBackground,
    minHeight: '95%',
    padding: '12px',
    overflowY: 'auto'
  }
}

const timeLabel = (val: any) => {
  const timeData = displayTime(val)
  return timeData ? timeData : '-'
}
export const formatters: any = {
  startCase,
  dateFormatterTZ: dateFormatter
}

export const History = ({
  data,
  selectedId,
  onSelect,
  histories,
  selectedRoute,
  routes,
  setSelectedRoute,
  historySlider,
  currHistorySlider,
  setCurrHistorySlider,
  config,
  onTrackingProviderChange,
  trackingProvider: appliedTrackingProvider
}: any) => {
  const { trackingProviders = [], trackingProvider: tripTrackingProvider } = data || {}
  const defaultTrackingProvider = appliedTrackingProvider || tripTrackingProvider
  const {
    config: {
      tabsComponent: {
        history: {
          historyColumns = [],
          historyDownloadCsvColumns = historyCSVColumns
        }
      }
    }
  } = config

  const columnWidth: string = historyColumns
    .map((column: any) => {
      const { width = '100px' } = column
      return width
    })
    .join(' ')

  const { t } = useTranslation()
  const [selectedTrackingProvider, setSelectedTrackingProvider] = React.useState<any>(null)
  const [isSubmitting, setIsSubmitting] = React.useState(false)

  React.useEffect(() => {
    setIsSubmitting(false)
  }, [histories])

  React.useEffect(() => {
    if (defaultTrackingProvider) {
      setSelectedTrackingProvider({
        label: startCase(defaultTrackingProvider),
        value: defaultTrackingProvider
      })
    }
  }, [defaultTrackingProvider])

  const handleTrackingProviderChange = (item: any) => {
    setSelectedTrackingProvider(item)
  }

  const handleSubmit = () => {
    if (onTrackingProviderChange) {
      setIsSubmitting(true)
      onTrackingProviderChange(selectedTrackingProvider?.value || '')
    }
  }

  function getColumnsValue(history: any, index1: number) {
    return (
      <Grid
        gridTemplateColumns={columnWidth}
        style={{ marginTop: 16 }}
        key={`Grid-${index1}`}
      >
        {historyColumns.map((item: any, index2: number) => {
          const { key, label, formatter } = item
          switch (key) {
            case 'radioInput':
              return (
                <Input
                  key={`${key}${index1}${index2}`}
                  type="radio"
                  checked={
                    `${history.vehicleNo}${history.gpsTimestamp}` ===
                    selectedId.location
                  }
                  onChange={() => {
                    onSelect({
                      location: `${history.vehicleNo}${history.gpsTimestamp}`
                    })
                  }}
                />
              )
            case 'landmark':
              return (
                <Span key={`${key}${index1}${index2}`}>
                  {history &&
                    history.landmark &&
                    history.landmark.split('/').join('<br/>')}
                </Span>
              )
            case 'gpsTimestamp':
              return (
                <Flex key={`${key}${index1}${index2}`} column>
                  <Span>{displayTime(history.gpsTimestamp, 'hhmma')}</Span>
                  <Span>{displayTime(history.gpsTimestamp, 'ddMMMMYYYY')}</Span>
                </Flex>
              )
            default:
              let value = getValueFromNestedKey(history, key)
              let formattedValue =
                formatter && formatters[formatter]
                  ? (value && formatters[formatter](value)) || '-'
                  : (!!value && typeof value === 'string' ? t(value) : value) ||
                    (value === 0 ? 0 : '-')
              if (formatter === 'startCase') {
                formattedValue = t(formattedValue)
              }
              if (key === 'extraData.temperature') {
                formattedValue = formattedValue === '-' ? null : formattedValue
                formattedValue = parseTemperature(
                  formattedValue ??
                    getValueFromNestedKey(history, 'extraData.sensorData')
                )
                formattedValue = formattedValue ? `${formattedValue}°C` : ''
              }
              if (key === 'extraData.doors') {
                formattedValue = parseDoorData(
                  getValueFromNestedKey(history, 'extraData.sensorData')
                )
              }
              if (key === 'extraData.voltage') {
                formattedValue = formattedValue === '-' ? null : formattedValue
                const loadsensor = getValueFromNestedKey(
                  history,
                  'extraData.loadsensor'
                )
                formattedValue = parseVoltage(loadsensor, formattedValue)
              }
              return (
                <Span key={`${key}${index1}${index2}`}>{formattedValue}</Span>
              )
          }
        })}
      </Grid>
    )
  }

  const { packageLegs = [] } = data
  const safeMin = currHistorySlider?.min && isFinite(currHistorySlider.min) ? currHistorySlider.min : null
  const safeMax = currHistorySlider?.max && isFinite(currHistorySlider.max) ? currHistorySlider.max : null
  const [historyValue, setHistoryValue] = React.useState<any>({ min: safeMin, max: safeMax })

  React.useEffect(() => {
    if (currHistorySlider?.min && isFinite(currHistorySlider.min) && isFinite(currHistorySlider.max)) {
      setHistoryValue({ min: currHistorySlider.min, max: currHistorySlider.max })
    }
  }, [currHistorySlider])
  return (
    <Flex column style={style.tripTabs}>
      <Flex justifyContentSpaceBetween>
        <Span style={{ fontSize: '14px', fontWeight: 600 }}>
          {t('History')}
        </Span>
        <Flex justifyContentFlexEnd>
          <SearchSelect
            options={trackingProviders.map((p: string) => ({ label: startCase(p), value: p }))}
            value={selectedTrackingProvider}
            placeholder={t('Select Source')}
            onChange={(item: any) => handleTrackingProviderChange(item)}
            isSearchable={false}
            t={t}
            style={{
              wrapper: {
                width: '122px',
                marginRight: '6px'
              },
              singleValue: {
                fontSize: '12px'
              },
              option: { fontSize: '12px' },
              placeholder: {
                fontSize: '12px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                color: 'rgba(90,90,90,1)'
              },
              dropdownIndicator: {
                display: 'block',
                transform: 'rotate(0deg) !important'
              },
              indicatorSeparator: {
                display: 'none'
              }
            }}
          />
          <Button
            variant="primary s"
            onClick={handleSubmit}
            disabled={isSubmitting}
            isLoading={isSubmitting}
            style={{ marginRight: '6px', fontSize: '11px', padding: '4px 8px' }}
          >
            {t('Apply')}
          </Button>
          {!isEmpty(packageLegs) && (
            <SearchSelect
              options={routes || []}
              value={selectedRoute}
              placeholder={t('Select Route')}
              onChange={(item: any) => {
                setSelectedRoute(item)
              }}
              t={t}
              style={{
                wrapper: {
                  width: '180px'
                },
                singleValue: {
                  fontSize: '12px'
                },
                option: { fontSize: '12px' }
              }}
            />
          )}
          {!isEmpty(histories) && (
            <PopOverDownloadCSV
              fileName={data?.lrNo || data?.shipmentNo}
              dataCSV={formatForCSV(histories, historyDownloadCsvColumns)}
            />
          )}
        </Flex>
      </Flex>
      {!isEmpty(histories) &&
        !isSubmitting &&
        isFinite(historySlider.min) && isFinite(historySlider.max) &&
        historyValue?.min && isFinite(historyValue.min) &&
        historyValue?.max && isFinite(historyValue.max) && (
        <Range
          formatLabel={(value: any) => timeLabel(value)}
          maxValue={historySlider.max}
          minValue={historySlider.min}
          value={historyValue}
          onChange={(value: any) => {
            setHistoryValue(value)
          }}
          onChangeComplete={(value: any) => setCurrHistorySlider(value)}
        />
      )}

      {isSubmitting ? (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {t('Fetching pings...')}
        </Label>
      ) : !isEmpty(histories) ? (
        !isEmpty(historyColumns) ? (
          <Flex column>
            <Grid gridTemplateColumns={columnWidth} style={{ marginTop: 16 }}>
              {historyColumns.map((item: any, index: number) => {
                const { label } = item
                return (
                  <Span
                    key={`label${index}`}
                    variant={'ellipsis secondary'}
                    style={{ fontWeight: 700 }}
                  >
                    {t(label)}
                  </Span>
                )
              })}
            </Grid>
            {histories.map((history: any, index: number) => {
              return getColumnsValue(history, index)
            })}
          </Flex>
        ) : (
          <Flex column>
            <Grid
              gridTemplateColumns={'30px auto 95px'}
              style={{ marginTop: 16 }}
            >
              <Span></Span>
              <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
                {t('Landmark')}
              </Span>
              <Span variant={'ellipsis secondary'} style={{ fontWeight: 700 }}>
                {t('Time')}
              </Span>
            </Grid>
            {histories.map((item: any, index: number) => (
              <Grid
                gridTemplateColumns={'30px auto 95px'}
                style={{ marginTop: 16 }}
                key={`history-${index}`}
              >
                <Input
                  type="radio"
                  checked={
                    `${item.vehicleNo}${item.gpsTimestamp}` ===
                    selectedId.location
                  }
                  onChange={() => {
                    onSelect({
                      location: `${item.vehicleNo}${item.gpsTimestamp}`
                    })
                  }}
                />
                <Span>
                  {item &&
                    item.landmark &&
                    item.landmark.split('/').join('<br/>')}
                </Span>
                <Flex column>
                  <Span>{displayTime(item.gpsTimestamp, 'hhmma')}</Span>
                  <Span>{displayTime(item.gpsTimestamp, 'ddMMMMYYYY')}</Span>
                </Flex>
              </Grid>
            ))}
          </Flex>
        )
      ) : (
        <Label
          style={{
            width: '100%',
            paddingTop: '10vmax',
            textAlign: 'center',
            display: 'block'
          }}
        >
          {t('No Data')}
        </Label>
      )}
    </Flex>
  )
}
